/* Bradford Sports · scroll reveal (progressive enhancement).
   Sections mark elements with .bs-reveal. Nothing is hidden until this script
   confirms it is running (html.bs-js), so a JS failure never hides a section. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return;
  document.documentElement.classList.add('bs-js');
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  var arm = function () {
    document.querySelectorAll('.bs-reveal:not(.is-in)').forEach(function (el) { io.observe(el); });
  };
  arm();
  document.addEventListener('shopify:section:load', arm);
  document.addEventListener('shopify:section:reorder', arm);
})();

/* Bradford Sports · one founding number per order.
   A Golf Club number is a seat, not merchandise — two in one cart would sell the
   same seat twice. Shopify has no per-order limit outside B2B, so the theme holds
   the line: the quantity field is pinned to 1 on that product page, and any cart
   line that still climbs above 1 is corrected before checkout. */
(function () {
  var LIMITED = 'bgc-founding-number';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var correcting = false;

  function isLimitedPage() {
    return window.location.pathname.indexOf('/products/' + LIMITED) !== -1;
  }

  /* Dawn's <quantity-input> rewrites min/max from its own rules after we run, so
     the pin is re-applied on the events that trigger that rewrite rather than once. */
  function pinQuantity() {
    if (!isLimitedPage()) return;
    document.querySelectorAll('input[name="quantity"]').forEach(function (input) {
      input.value = '1';
      input.setAttribute('min', '1');
      input.setAttribute('max', '1');
      input.readOnly = true;
      var wrap = input.closest('quantity-input') || input.parentElement;
      if (!wrap) return;
      wrap.querySelectorAll('button').forEach(function (b) { b.disabled = true; });
    });
  }

  function repin() {
    pinQuantity();
    setTimeout(pinQuantity, 300);
  }

  function correctCart() {
    if (correcting) return;
    correcting = true;
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var over = (cart.items || []).filter(function (i) {
          return i.handle === LIMITED && i.quantity > 1;
        })[0];
        if (!over) { correcting = false; return; }
        return fetch(root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: over.key, quantity: 1 })
        }).then(function () { window.location.reload(); });
      })
      .catch(function () { correcting = false; });
  }

  function watchDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    new MutationObserver(function () {
      if (drawer.classList.contains('active')) correctCart();
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  function start() {
    repin();
    watchDrawer();
    if (isLimitedPage()) {
      document.addEventListener('change', repin);
      document.addEventListener('variant:change', repin);
    }
    if (window.location.pathname.indexOf('/cart') === 0) correctCart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', repin);
})();

/* Bradford Sports · site-wide soundtrack player.
   Does nothing until a visitor taps "Play the soundtrack" (bradford-soundtrack
   section, Western Supply). Once playing, the song keeps going as they click into
   products and other pages: the spot in the song is saved in sessionStorage and
   picked up on the next page. If a browser wants a new tap before it continues
   (iPhones often do), the corner pill turns into "Keep listening" so one tap
   resumes it. The audio file only downloads after the first tap. */
(function(){
    if (window.BSSound) return;
    var holder = document.createElement('div');
    holder.innerHTML = "<div class=\"bs-player\" data-bs-player hidden><button type=\"button\" class=\"bs-player__pill\" data-bs-player-pill aria-label=\"Pause the soundtrack\"><span class=\"bs-player__bars\" aria-hidden=\"true\"><i></i><i></i><i></i><i></i></span><svg class=\"bs-player__play\" viewBox=\"0 0 16 16\" width=\"11\" height=\"11\" aria-hidden=\"true\"><path d=\"M4 2.5v11l9-5.5z\" fill=\"currentColor\"/></svg><span class=\"bs-player__text\" data-bs-player-text></span><svg class=\"bs-player__pause\" viewBox=\"0 0 16 16\" width=\"11\" height=\"11\" aria-hidden=\"true\"><path d=\"M4 2.5h3v11H4zM9 2.5h3v11H9z\" fill=\"currentColor\"/></svg></button><audio data-bs-player-audio preload=\"none\" loop></audio></div>";
    var st = document.createElement('style');
    st.textContent = ".bs-player[hidden]{display:none}.bs-player__pill{position:fixed;left:16px;bottom:16px;z-index:40;display:inline-flex;align-items:center;gap:10px;padding:10px 14px;border-radius:999px;background:var(--bs-ink,#141210);color:var(--bs-bone,#f2eee7);border:1px solid rgba(242,238,231,.3);box-shadow:0 6px 20px rgba(20,18,16,.22);cursor:pointer;font:inherit;opacity:0;transform:translateY(8px);transition:opacity .25s,transform .25s}.bs-player.is-shown .bs-player__pill{opacity:1;transform:none}.bs-player__pill:focus-visible{outline:2px solid var(--bs-bone,#f2eee7);outline-offset:3px}.bs-player__text{font-family:var(--bs-display);text-transform:uppercase;letter-spacing:.08em;font-size:1.2rem;line-height:1}.bs-player__bars{display:flex;align-items:flex-end;gap:2px;height:12px}.bs-player__bars i{display:block;width:2px;height:40%;background:currentColor;border-radius:1px}.bs-player.is-playing .bs-player__bars i{animation:bsBar 1.1s ease-in-out infinite}.bs-player.is-playing .bs-player__bars i:nth-child(2){animation-delay:-.35s}.bs-player.is-playing .bs-player__bars i:nth-child(3){animation-delay:-.7s}.bs-player.is-playing .bs-player__bars i:nth-child(4){animation-delay:-.2s}.bs-player__play{display:none}.bs-player.is-blocked .bs-player__play{display:block}.bs-player.is-blocked .bs-player__bars,.bs-player.is-blocked .bs-player__pause{display:none}@keyframes bsBar{0%,100%{height:30%}50%{height:100%}}@media screen and (max-width:749px){.bs-player:not(.is-blocked) .bs-player__text{display:none}.bs-player:not(.is-blocked) .bs-player__pill{padding:12px 13px;gap:8px}}@media (prefers-reduced-motion:reduce){.bs-player.is-playing .bs-player__bars i{animation:none;height:70%}.bs-player__pill{transition:none}}";
    document.head.appendChild(st);
    document.body.appendChild(holder.firstElementChild);
    var KEY = 'bsSound';
    var MAX_GAP = 30 * 60 * 1000; // forget the song after 30 minutes away
    var root = document.querySelector('[data-bs-player]');
    var audio = root.querySelector('[data-bs-player-audio]');
    var pill = root.querySelector('[data-bs-player-pill]');
    var text = root.querySelector('[data-bs-player-text]');

    var cfg = { src: '', title: '', vol: 0.55 };
    var want = false;      // the visitor wants music on
    var blocked = false;   // the browser needs a new tap before it will continue
    var anchorVisible = false; // the page's own play button is on screen
    var fading = null, lastSave = 0, listeners = [];

    function read(){ try { return JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch(e){ return null; } }
    function save(force){
      var now = Date.now();
      if (!force && now - lastSave < 1000) return;
      lastSave = now;
      try {
        sessionStorage.setItem(KEY, JSON.stringify({
          src: cfg.src, title: cfg.title, vol: cfg.vol,
          t: audio.currentTime || 0, playing: want, ts: now
        }));
      } catch(e){}
    }
    function fadeTo(target, ms, done){
      clearInterval(fading);
      var start = audio.volume, steps = Math.max(1, Math.round(ms / 40)), i = 0;
      fading = setInterval(function(){
        i++;
        audio.volume = Math.min(1, Math.max(0, start + (target - start) * (i / steps)));
        if (i >= steps){ clearInterval(fading); if (done) done(); }
      }, 40);
    }
    function render(){
      var playing = want && !blocked;
      root.classList.toggle('is-playing', playing);
      root.classList.toggle('is-blocked', want && blocked);
      text.textContent = (want && blocked) ? 'Keep listening' : cfg.title;
      pill.setAttribute('aria-label', (want && blocked) ? 'Keep listening to ' + cfg.title : 'Pause the soundtrack: ' + cfg.title);
      var show = want && !anchorVisible;
      if (show){
        root.hidden = false;
        requestAnimationFrame(function(){ root.classList.add('is-shown'); });
      } else {
        root.classList.remove('is-shown');
        setTimeout(function(){ if (!(want && !anchorVisible)) root.hidden = true; }, 280);
      }
      listeners.forEach(function(fn){ try { fn(playing); } catch(e){} });
    }
    function tryPlay(){
      audio.volume = 0;
      var p = audio.play();
      if (p && p.then){
        p.then(function(){ blocked = false; render(); fadeTo(cfg.vol, 900); })
         .catch(function(){ blocked = true; render(); armGesture(); });
      } else {
        fadeTo(cfg.vol, 900);
      }
    }
    // If the browser held the song back on this page, the visitor's next tap or
    // key press anywhere on the page picks it back up.
    var armed = false;
    function armGesture(){
      if (armed) return;
      armed = true;
      var evs = ['click', 'touchend', 'keydown'];
      var go = function(e){
        if (e && e.target && e.target.closest && e.target.closest('[data-bs-player-pill],[data-bs-sound-toggle]')) return;
        evs.forEach(function(ev){ document.removeEventListener(ev, go, true); });
        armed = false;
        if (want && blocked) tryPlay();
      };
      evs.forEach(function(ev){ document.addEventListener(ev, go, true); });
    }
    function load(src, t){
      if (audio.getAttribute('src') !== src) audio.setAttribute('src', src);
      if (t > 0){
        var seek = function(){
          var d = audio.duration;
          audio.currentTime = (d && isFinite(d)) ? (t % d) : t;
        };
        if (audio.readyState >= 1) seek(); else audio.addEventListener('loadedmetadata', seek, { once: true });
      }
    }

    var api = {
      play: function(opts){
        if (opts){
          if (opts.src && opts.src !== cfg.src){ cfg.src = opts.src; load(cfg.src, 0); }
          if (opts.title) cfg.title = opts.title;
          if (opts.vol) cfg.vol = opts.vol;
        }
        if (!cfg.src) return;
        want = true; blocked = false; render(); tryPlay(); save(true);
      },
      pause: function(){
        want = false; blocked = false; render(); save(true);
        fadeTo(0, 400, function(){ audio.pause(); save(true); });
      },
      toggle: function(opts){ (want && !blocked) ? api.pause() : api.play(opts); },
      isPlaying: function(){ return want && !blocked; },
      onChange: function(fn){ listeners.push(fn); fn(want && !blocked); },
      watchAnchor: function(el){
        if (!('IntersectionObserver' in window)) return;
        new IntersectionObserver(function(entries){
          anchorVisible = entries[0].isIntersecting; render();
        }).observe(el);
      }
    };
    window.BSSound = api;
    document.dispatchEvent(new CustomEvent('bs:sound-ready'));

    pill.addEventListener('click', function(){
      if (want && blocked) api.play(); else api.pause();
    });
    audio.addEventListener('timeupdate', function(){ if (want) save(false); });
    window.addEventListener('pagehide', function(){ save(true); });

    function resume(){
      var s = read();
      if (!s || !s.playing || !s.src || (Date.now() - s.ts) > MAX_GAP) return;
      cfg.src = s.src; cfg.title = s.title || cfg.title; cfg.vol = s.vol || cfg.vol;
      var gap = Math.max(0, (Date.now() - s.ts) / 1000);
      load(cfg.src, (s.t || 0) + Math.min(gap, 5));
      want = true; render(); tryPlay();
    }
    resume();

    // Coming back with the browser's Back button can restore a frozen copy of
    // the page; pick the song back up from where the last page left it.
    window.addEventListener('pageshow', function(e){
      if (!e.persisted) return;
      var s = read();
      if (s && s.playing && audio.paused){
        load(s.src, (s.t || 0) + Math.min(Math.max(0, (Date.now() - s.ts) / 1000), 5));
        cfg.src = s.src; want = true; render(); tryPlay();
      } else if (s && !s.playing && !audio.paused){
        want = false; render(); audio.pause();
      }
    });
  })();
